<ng-template loadComponent></ng-template>